var IECList = {
  'IEC_A+': [
    1.143,
    0.639,
    0.471,
    0.387,
    0.3366,
    0.303,
    0.279,
    0.261,
    0.247,
    0.2358,
    0.2266,
    0.219,
    0.2125,
    0.207,
    0.2022,
    0.198,
    0.1943,
    0.191,
    0.1881,
    0.1854,
    0.183,
    0.1808,
    0.1788,
    0.177,
    0.1753,
    0.1738,
    0.1723,
    0.171,
    0.1698,
    0.1686
  ],
  IEC_A: [
    1.016,
    0.568,
    0.4187,
    0.344,
    0.2992,
    0.2693,
    0.248,
    0.232,
    0.2196,
    0.2096,
    0.2015,
    0.1947,
    0.1889,
    0.184,
    0.1797,
    0.176,
    0.1727,
    0.1698,
    0.1672,
    0.1648,
    0.1627,
    0.1607,
    0.159,
    0.1573,
    0.1558,
    0.1545,
    0.1532,
    0.152,
    0.1509,
    0.1499
  ],
  IEC_B: [
    0.889,
    0.497,
    0.3663,
    0.301,
    0.2618,
    0.2357,
    0.217,
    0.203,
    0.1921,
    0.1834,
    0.1763,
    0.1703,
    0.1653,
    0.161,
    0.1573,
    0.154,
    0.1511,
    0.1486,
    0.1463,
    0.1442,
    0.1423,
    0.1406,
    0.1391,
    0.1377,
    0.1364,
    0.1352,
    0.134,
    0.133,
    0.132,
    0.1311
  ],
  IEC_C: [
    0.762,
    0.426,
    0.314,
    0.258,
    0.2244,
    0.202,
    0.186,
    0.174,
    0.1647,
    0.1572,
    0.1511,
    0.146,
    0.1417,
    0.138,
    0.1348,
    0.132,
    0.1295,
    0.1273,
    0.1254,
    0.1236,
    0.122,
    0.1205,
    0.1192,
    0.118,
    0.1169,
    0.1158,
    0.1149,
    0.114,
    0.1132,
    0.1124
  ]
};
export default IECList;
